import clsx from 'clsx';
import { ReactNode } from 'react';

type ItemRowProps = {
  label: string;
  value: ReactNode | string;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
};

export function ItemRow({
  label,
  value,
  className,
  valueClassName,
  labelClassName,
}: Readonly<ItemRowProps>) {
  return (
    <div
      className={clsx(
        'flex justify-between items-center text-background-dark dark:text-background-light',
        className
      )}
    >
      <div className={clsx('text-R-16 text-wl-on-surface', labelClassName)}>
        {label}
      </div>
      <div className={clsx('text-R-16 text-wl-on-surface', valueClassName)}>
        {value}
      </div>
    </div>
  );
}
